import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LangContext";

const HERO_IMG = "/site_assets/contact1.jpg";

export default function HeroSection() {
    const { t } = useLang();
    return (
        <section data-testid="hero-section"
                 className="relative min-h-[88vh] flex items-end overflow-hidden">
            <img src={HERO_IMG} alt="Elite training" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 hero-overlay" />
            <div className="absolute inset-0 hairline-grid opacity-30" />
            <div className="relative z-10 px-6 md:px-12 lg:px-20 pb-20 md:pb-28 w-full">
                <div className="max-w-4xl">
                    <div className="mb-6">
                        <span className="font-body text-xs md:text-sm uppercase tracking-[0.25em] text-volt">
                            {t("hero_tag")}
                        </span>
                    </div>
                    <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading uppercase leading-[0.9]">
                        {t("hero_line1")}<br />
                        <span className="text-volt">{t("hero_line2")}</span>
                    </h1>
                    <p className="mt-8 text-base md:text-lg text-white/70 max-w-2xl leading-relaxed">
                        {t("hero_body")}
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row gap-4">
                        <Link to="/programs" data-testid="hero-cta-programs"
                              className="btn-volt px-8 py-4 text-base inline-flex items-center gap-2">
                            {t("hero_cta_programs")} <ArrowUpRight size={18} />
                        </Link>
                        <Link to="/trainings" data-testid="hero-cta-book"
                              className="btn-ghost-outline px-8 py-4 text-base inline-flex items-center gap-2">
                            {t("hero_cta_book")}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
